"use client";

import type { ReactNode } from "react";

import { useState } from "react";
import { useTranslations } from "next-intl";
import { clsx } from "clsx";

import { Dialog } from "@/app/_ui/components/core/DialogRedesign";
import { Button } from "@/app/_ui/components/core/Button";
import IconExpandSimple from "@/app/_ui/central-icons/icons/IconExpandSimple";
import { iconStrokeFix } from "@/app/_ui/central-icons/iconUtils";
import { ICON_ALIGN_OPTIONS } from "@/app/_ui/tokens/icon-types";

interface BentoGridItemDialogButtonProps {
  title: string;
  children: ReactNode;
}

export function BentoGridItemDialogButton({ title, children }: BentoGridItemDialogButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations("ClientKeys.Globals");

  return (
    <>
      <Button
        aria-label={t("expand")}
        className='tw-pointer-events-auto tw-absolute tw-top-3 tw-right-3 tw-z-30'
        icon={<IconExpandSimple className={clsx(iconStrokeFix, "tw-size-4")} />}
        iconPosition={ICON_ALIGN_OPTIONS.AFTER}
        onClick={() => setIsOpen(true)}
        size='pill'
        type='button'
        variant='elevated'
      />

      <Dialog isDismissable isOpen={isOpen} onOpenChange={setIsOpen} title={title}>
        {children}
      </Dialog>
    </>
  );
}
